import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../core/auth.service";
import { Observable } from "rxjs/Observable";
import { AngularFireAuth } from 'angularfire2/auth';

import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";
import { MessagingService } from "../../services/messaging.service";
import { Message } from "../../models/message";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"]
})
export class NavbarComponent implements OnInit {
  myUser;
  isLoggedIn$: Observable<boolean>;
  loginStateTEST;

  messageCollection: AngularFirestoreCollection<Message>;
  messages: Observable<Message[]>;


  currentUser = 'test';

  newMessageCount = 0;

  constructor(
    private messagingService: MessagingService,
    public auth: AuthService,
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth
  ) {
    this.myUser = this.auth.getUserObject();
    console.log("logged in User", this.myUser);

       // get my user Id 
       this.afAuth.authState.subscribe(userData => {
        this.currentUser = userData.uid;
        console.log('Should be my user id', this.currentUser);

        this.messageCollection = this.afs.collection("messages", ref => {
          return ref
            .where("sendTo", "==", this.currentUser)
            .where("archived", "==", false)
            .orderBy("createdAt", "desc");
        });
        this.messages = this.messageCollection.valueChanges();
    
        this.messages.subscribe(ref => {
          console.log(ref.length);
          this.newMessageCount = ref.length;
        });

     
    });
    console.log(this.currentUser);
  

  }

  ngOnInit() {


  
  }

  toggleBurger() {
    var nav = document.getElementById("nav-menu");
    var className = nav.getAttribute("class");
    if (className === "navbar-menu") {
      nav.className = "navbar-menu is-active";
    } else {
      nav.className = "navbar-menu";
    }
  }

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/navbar/navbar.component.ts